module.exports = __webpack_public_path__ + "static/media/flowers_2.4d5e6a30.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_2.csv
// module id = 759
// module chunks = 0